import React from "react";
import "./Cards.css";

const Card3 = ({ title, heading, link, image }) => {
  return (
    <div className="card__three_wrap">
      <div className="card__three_header">
        <img src={image} alt="" className="card__three_headerimg" />
      </div>
      <div className="card__three_body">
        <div className="card__three_title">{title}</div>
        <div className="card__three_heading">{heading}</div>
        <a className="card__three_link" href="#">
          Read More <span className="card__three_linkarrow">{"->"}</span>
        </a>
      </div>
    </div>
  );
};

export default Card3;
